import React, { useRef } from 'react';
import cn from 'classnames';

import { ReactComponent as FilterIcon } from './icons/filterIcon.svg';

import { worksNameList, worksNameListUA } from '../../data/worksData';

import styles from './Works.module.css';
import { useOutsideClick } from '../../hooks/hooks';

export default function WorksNameList({
    isNameListOpen,
    listNameActive,
    toggleListNameActive,
    onWorksNameListClose,
    onWorksNameListToggler,
    language,
}) {
    const worksNameListRef = useRef(null);

    useOutsideClick(worksNameListRef, onWorksNameListClose, isNameListOpen);

    return (
        <div ref={worksNameListRef}>
            <button
                id="filterButton"
                className={cn(styles.filterButtonWrapper)}
                onClick={() => onWorksNameListToggler()}
                aria-label="dropdown-list-toggler"
            >
                <FilterIcon
                    className={cn(styles.filterButton, {
                        [styles.filterButtonActive]: isNameListOpen,
                    })}
                />
                <div>{listNameActive}</div>
            </button>
            <ul
                className={cn(styles.worksNameList, {
                    [styles.worksNameListOpen]: isNameListOpen,
                })}
            >
                {(language === 'en' ? worksNameList : worksNameListUA).map(
                    (worksNameItem) => (
                        <li
                            key={worksNameItem.tag}
                            className={cn(styles.worksNameItem, {
                                [styles.worksNameItemActive]:
                                    listNameActive === worksNameItem.tag,
                            })}
                            onClick={() =>
                                toggleListNameActive(worksNameItem.tag)
                            }
                        >
                            {worksNameItem.value}
                        </li>
                    )
                )}
            </ul>
        </div>
    );
}
